import React, { useState } from 'react';
import { BsBuilding, BsCheck, BsExclamation, BsLock } from 'react-icons/bs';
import { FiMonitor } from 'react-icons/fi'
import { Loader } from 'semantic-ui-react';
import { styleSheet } from '../../assets/styles/global';

import {
  Container, Dadge, DadgeContainer, Data, IconContainer, Line, OsInfo, OsInfosContainer, SubTitle, Title, LeftBadgeContainer
} from './styles';


interface Props {
  os: string;
  nomeCoordenador: string;
  local: string;
  title: string;
  subTitle: string;
  color: string;
  hour: number;
  status: string;
  isLoading?: boolean;
}

const Os: React.FC<Props> = ({ os, nomeCoordenador, local, title, subTitle, color, hour, status, isLoading }) => {
  return (
    <Container
      color={color}
      style={{ position: 'relative' }} // Ensure overlay is positioned correctly
    >
      {isLoading && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(255, 255, 255, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 10,
          borderRadius: 'inherit'
        }}>
          <Loader active inline size='tiny' />
        </div>
      )}
      <DadgeContainer>
        {
          hour > 0 && <Dadge className="badge-hour" color={styleSheet.warning}>{hour}h</Dadge>
        }
        <Dadge className="badge-coord" color={color}>{nomeCoordenador.split(" ").slice(0, 2).map((n) => n[0]).join("")}</Dadge>
      </DadgeContainer>
      <LeftBadgeContainer>
        {
          status === '1' &&
          <Dadge className="badge-status" color={styleSheet.error}>
            <BsExclamation color="#FFF" size={15} />
          </Dadge>
        }
        {
          status === '2' &&
          <Dadge className="badge-status" color={styleSheet.success}>
            <BsCheck color="#FFF" size={15} />
          </Dadge>
        }
        {
          status === '3' &&
          <Dadge className="badge-status" color="#666">
            <BsLock color="#FFF" size={12} />
          </Dadge>
        }

        {
          local === 'REMOTO'
            ?
            <Dadge className="badge-local" color={styleSheet.info}>
              <FiMonitor color="#FFF" size={15} />
            </Dadge>
            :
            <Dadge className="badge-local" color={styleSheet.warning}>
              <BsBuilding color="#FFF" size={15} />
            </Dadge>
        }
      </LeftBadgeContainer>
      <Data>
        <Title>{title}</Title>
        <SubTitle>{subTitle}</SubTitle>
      </Data>
    </Container>
  );
}

export default Os;